import React from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
// import { BlockUsersAction, DeleteUsersAction } from "store/middlewares/user";
import { InputTextarea } from "components/atoms";
import { Button } from "components/ui";
import { ImageStatusManage, ProfileImageStatus } from "store/middlewares/user";

const ModalRejectImage = ({ id, imageType }) => {
  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    if (imageType === "image") {
      dispatch(
        ImageStatusManage({
          id: id,
          status: "rejected",
          reason: values.reason,
        }),
      );
    } else {
      dispatch(
        ProfileImageStatus({
          id: id,
          status: "rejected",
          reason: values.reason,
        }),
      );
    }
  };

  const formik = useFormik({
    initialValues: {
      reason: "",
    },
    validationSchema: Yup.object({
      reason: Yup.string().required("Reason is required"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <InputTextarea
        textareaClassName="rounded-lg w-full px-2 py-2 mt-2 no-scrollbar"
        label={"Reason"}
        isRequired={false}
        name="reason"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        maxLength={250}
        error={formik.errors.reason && formik.touched.reason}
        errorMsg={formik.errors.reason}
        value={formik.values.reason}
        placeholder="Enter reason"
      />
      <div className="flex justify-end">
        <Button size={"lg"} type={"submit"}>
          Submit
        </Button>
      </div>
    </form>
  );
};

export default ModalRejectImage;
